export default "__VITE_ASSET__Ct9I2yD9__"